<template>
    <div style="width: 100%">
        <OssDataTable
            :headers="headers"
            :items="accountingTransactions"
            :loading="loading"
            :striped="true"
            :dense="true"
            :height="height"
            :showSelect="addCheckBoxColumn"
            fixed-header
            :fixed-footer="true"
            item-key="index"
            :displayRowNumber="true"
            v-model="selectedAccountingTransactionKeys"
            :checkboxDisplayCondition="isCheckable"
            @clickRow="openAccountingTransaction($event)"
        >
            <template v-slot:item.status="{ item }">
                <v-icon
                    :color="statusColor(item)"
                    v-if="statusIcon(item) || item.stillOwe"
                    size="small"
                    >{{ statusIcon(item) }}</v-icon
                >
                <a class="ml-2" v-if="item.stillOwe">{{ status(item) }}</a>
                <a class="ml-1" v-if="item.mail">{{ formatMailStatus(item.mail) }}</a>
            </template>
            <template v-slot:item.type="{ item }">
                {{ getItemLog(item) }}
            </template>
            <template v-slot:item.wording="{ item }">
                <template v-if="item.tags">
                    <v-chip
                        label
                        :ripple="false"
                        v-for="(tag, index) of item.tags"
                        :key="index"
                        class="text mr-1"
                        size="x-small"
                    >
                        <span :style="'color:' + labelTextColor + ';'">{{ tag.name }}</span>
                    </v-chip>
                </template>
                <span>
                    {{ item.wording + (item.invoiceNumber ? " - " + item.invoiceNumber : "") }}
                </span>
            </template>
            <template v-slot:item.date="{ item }">
                {{ formatDate(item.date) }}
            </template>
            <template v-slot:item.amountSigned="{ item }">
                {{ newCommonFormatCurrency(item.debit - item.credit, undefined) }}
            </template>
            <template v-slot:item.stillOwe="{ item }">
                {{ formatStillOwe(item.stillOwe, item.object.type) }}
            </template>
            <template v-slot:item.action="{ item }">
                <v-menu
                    v-if="
                        item.object.type === 'document' ||
                        isBankTransactionWaitingClientResponse(item)
                    "
                    location="start"
                >
                    <template v-slot:activator="{ props }">
                        <v-tooltip location="top" v-bind="props">
                            <template v-slot:activator="{ props: propsTT }">
                                <v-btn-icon
                                    v-bind="{ ...propsTT, ...props }"
                                    size="small"
                                    icon="$dots_vertical"
                                >
                                </v-btn-icon>
                            </template>
                            <span>Plus d'options</span>
                        </v-tooltip>
                    </template>
                    <v-list density="compact">
                        <v-list-item
                            v-if="isBankTransactionWaitingClientResponse(item)"
                            @click.stop="$emit('bankTransactionSelected', item.object.id)"
                        >
                            <v-list-item-title>Répondre</v-list-item-title>
                            <template #append>
                                <v-icon size="x-small">$oss-chat</v-icon>
                            </template>
                        </v-list-item>
                        <v-divider v-if="isBankTransactionWaitingClientResponse(item)" />
                        <template v-if="item.object.type === 'document'">
                            <v-tooltip location="top" :disabled="item.object.original">
                                <template v-slot:activator="{ props }">
                                    <div v-bind="props" class="d-inline-block">
                                        <v-list-item
                                            :disabled="!item.object.original"
                                            @click="openMailDialog(item, false)"
                                            v-if="isForClients"
                                        >
                                            <v-list-item-title
                                                >Envoi de la facture</v-list-item-title
                                            >
                                            <template #append>
                                                <v-icon size="x-small">$oss-mail</v-icon>
                                            </template>
                                        </v-list-item>
                                    </div>
                                </template>
                                <span>Pas de facture</span>
                            </v-tooltip>
                            <v-list-item
                                @click="openReminderMailDialog(item, true, 1)"
                                v-if="isForClients"
                            >
                                <v-list-item-title>Relance 1</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                                @click="openReminderMailDialog(item, true, 2)"
                                v-if="isForClients"
                            >
                                <v-list-item-title>Relance 2</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                                @click="openReminderMailDialog(item, true, 3)"
                                v-if="isForClients"
                            >
                                <v-list-item-title>Relance 3</v-list-item-title>
                            </v-list-item>
                            <v-tooltip location="top" :disabled="mails.length > 0">
                                <template v-slot:activator="{ props }">
                                    <div v-bind="props" class="d-inline-block">
                                        <v-list-item
                                            :disabled="mails.length === 0"
                                            @click="accessToMails()"
                                        >
                                            <v-list-item-title
                                                >Accéder à la correspondance</v-list-item-title
                                            >
                                        </v-list-item>
                                    </div>
                                </template>
                                <span>Pas de correspondance</span>
                            </v-tooltip>
                        </template>
                    </v-list>
                </v-menu>
            </template>
            <template v-slot:body.append>
                <tr class="x-dense">
                    <!-- :colspan="enableLettering ? (isIncomingOutgoingPayment ? 4:3):(isIncomingOutgoingPayment ? 2:1)" -->
                    <td class="text-start" colspan="20">
                        <div style="width: 100%" class="d-flex align-center">
                            <!-- <v-btn
                            v-if="addCheckBoxColumn && !!accountableAccountReplacementRule && accountableAccountInfo.name==='471000'"
                            rounded size=“x-small”
                            class="ml-2"
                            color="ternary"
                            elevation="0"
                            @click.stop="openAccountableAccountDialog=true"
                        >
                            {{modifyAATitle}}
                        </v-btn> -->
                            <!-- <template  v-if="openAccountableAccountDialog"> -->
                            <AccountableAccount
                                :showLabel="true"
                                :needValidation="true"
                                :showValidation="false"
                                :companyId="companyId"
                                :accountableAccountReplacementRule="
                                    accountableAccountReplacementRule
                                "
                                :inAccountableAccount="accountableAccountInfo"
                                :btn-mode="true"
                                :label="modifyAATitle"
                                :disabled="
                                    !selectedAccountingTransactionCount || !enableModification
                                "
                                :thirdParty="thirdPartyCompany || user"
                                :defineThirdParty="true"
                                @validated="validAA($event)"
                                @dialogClosed="openAccountableAccountDialog = false"
                                v-if="
                                    addCheckBoxColumn &&
                                    !!accountableAccountReplacementRule &&
                                    accountableAccountInfo.name === '471000'
                                "
                            >
                                <template v-slot:activator="{ props }">
                                    <v-btn
                                        v-bind="props"
                                        rounded
                                        class="ml-2"
                                        color="ternary"
                                        elevation="0"
                                        :disabled="!selectedAccountingTransactionCount"
                                        @click.stop="openAccountableAccountDialog = true"
                                        size="x-small"
                                    >
                                        {{ modifyAATitle }}
                                    </v-btn>
                                    <!-- <v-btn
                                        v-if="!!accountableAccountReplacementRule"
                                        v-on="on"
                                        rounded size=“x-small”
                                        class="ml-2"
                                        color="ternary"
                                        elevation="0"
                                        :disabled="!selectedAccountingTransactionCount"
                                        @click.stop="openAccountableAccountDialog=true"
                                    >
                                        Modifier le compte
                                    </v-btn> -->
                                </template>
                            </AccountableAccount>
                            <!-- </template> -->
                            <v-btn
                                rounded="circle"
                                color="ternary"
                                elevation="0"
                                :disabled="!selectedBankTransactionsForMessage.length"
                                @click="showCreateBankTransactionMessageDialog = true"
                                v-if="addCheckBoxColumn && openPointMode"
                                class="ml-2"
                                size="x-small"
                                icon="$fa-comments"
                            >
                            </v-btn>
                            <CreateBTChatMessage
                                v-model:active="showCreateBankTransactionMessageDialog"
                                :companyId="selectedCompany.id"
                                :bankTransactions="selectedBankTransactionsForMessage"
                                v-if="addCheckBoxColumn && openPointMode"
                                @message-created="refresh($event)"
                            >
                                >
                            </CreateBTChatMessage>
                            <v-btn
                                rounded
                                elevation="0"
                                class="ml-2"
                                :disabled="disabledPaymentManager"
                                @click="
                                    reminder = true;
                                    paymentManagerDialog = true;
                                "
                                v-if="addCheckBoxColumn && showPaymentManager"
                                size="small"
                            >
                                Gérer
                            </v-btn>
                        </div>
                    </td>
                </tr>
            </template>
        </OssDataTable>
        <oss-dialog
            v-model="showAccountingTransactionDialog"
            :withoutHeader="true"
            transition="dialog-bottom-transition"
            @close="closeDocRecDialog"
            height="100vh"
            width="100vw"
            :hideValid="showDocument ? true : false"
        >
            <v-row class="d-flex justify-center" v-if="showDocument">
                <v-col cols="12" style="overflow-y: auto">
                    <document
                        :mode="'GeneralLedger'"
                        :companyId="selectedCompany.id"
                        :id="documentId"
                        :dark-mode="true"
                        @reload="onDocumentUpdated()"
                        @deleted="onDocumentDeleted()"
                        @task-ended="onDocumentUpdated()"
                    />
                </v-col>
            </v-row>
            <Reconciliation
                v-if="showReconciliation"
                :mode="'GeneralLedger'"
                :companyId="selectedCompany.id"
                :bankTransactionId="bankTransactionId"
                :reconciliationId="reconciliationId"
                @update="onReconciliationUpdated()"
            />
            <div class="text-center">
                <div class="bottom-sheet">
                    <div class="remote" style="pointer-events: auto">
                        <v-container class="controller elevation-1">
                            <v-btn-prev :disabled="previousDisabled()" @click.stop="previous()" />
                            <v-btn-next :disabled="nextDisabled()" @click.stop="next()" />
                        </v-container>
                    </div>
                </div>
            </div>
        </oss-dialog>

        <MailerDialog
            v-model="sendMailDialog"
            :mailType="documentDefaultMailerInfos.mailType"
            :defaultSubject="documentDefaultMailerInfos.defaultSubject"
            :defaultText="documentDefaultMailerInfos.defaultText"
            :companyId="companyId"
            :thirdPartyCompanyId="thirdPartyCompanyId"
            :listDocuments="resetedSelectedAccountingTransactions"
            :withAttachment="documentDefaultMailerInfos.withAttachment"
            v-if="sendMailDialog"
        />

        <PaymentManagement
            v-model="paymentManagerDialog"
            :companyId="companyId"
            :inThirdPartyName="thirdPartyName"
            :inThirdPartyCompanyId="thirdPartyCompanyId"
            :inThirdPartyUserId="thirdPartyUserId"
            :inAccountableAccountName="accountableAccountInfo.name"
            :inAccountingTransactions="resetedSelectedAccountingTransactions"
            :forCustomer="isForClients"
            @actionDone="onActionDone"
            v-if="paymentManagerDialog"
        />
        <oss-dialog
            v-model="switchResultDialog"
            :title="'Notification'"
            :validTitle="'J\'ai compris'"
            @valid="switchResultDialog = false"
            width="800px"
        >
            <h3
                v-if="
                    switchResult &&
                    switchResult.accountingLines &&
                    switchResult.accountingLines.length === 0
                "
            >
                L'affectation n'a pu être effectuée sur aucune écriture car elle(s) est/sont
                lettrée(s) avec des écritures d'un exercice clos
            </h3>
            <h3 v-else>
                L'affectation n'a pu être effectuée sur certaines écriture(s) car elle(s) est/sont
                lettrée(s) avec des écritures d'un exercice clos
            </h3>
            <h4>Intangibilité du bilan d'ouverture</h4>
        </oss-dialog>
    </div>
</template>

<script lang="ts">
import moment from "moment-timezone";

import AccountableAccount from "./AccountableAccount.vue";
import CompanyTable from "./admin/CompaniesTable.vue";
import OssDataTable from "./ossComponents/ossDataTable2.vue";
import Document from "./document/DocumentRouter.vue";
import { AccountableAccountBalanceDetailBase } from "./AccountableAccountBalanceDetailBase";
import CreateBTChatMessage from "./chat/CreateBTChatMessage.vue";
import { getUserDisplayName } from "../services/userServices";
import MailerDialog from "./mail/MailerDialog.vue";
import PaymentManagement from "./pay/PaymentManagement.vue";
import Reconciliation from "./Reconciliation.vue";
// import { documentDefaultMailer } from "../../../backend/src/common/mail/mailerServices";

import GET_DEFAULT_MAILER from "@/graphql/company/GetDefaultMailer.gql";
import MAILS_FILTER_QUERY from "@/graphql/mail/FilterMails.gql";
import { Component, Prop, toNative } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import { Apollo } from "@/decorators";

@Component({
    name: "AccountableAccountBalanceDetailOpenPoints",
    components: {
        AccountableAccount,
        CompanyTable,
        Reconciliation,
        Document,
        CreateBTChatMessage,
        OssDataTable,
        MailerDialog,
        PaymentManagement,
    },
})
export class AccountableAccountBalanceDetailOpenPoints extends AccountableAccountBalanceDetailBase {
    @Prop({ default: false }) btOnly: boolean;

    sendMailDialog = false;
    paymentManagerDialog = false;

    payDialog = false;

    //oneDocument = null
    reminder = false;
    reminderType = 0;

    documentDefaultMailerInfos: any = {
        mailType: "",
        defaultSubject: "",
        defaultText: "",
        withAttachement: true,
    };

    // listDocumentsFromPaymentManagement = []
    totalFromPaymentManagement = 0;

    openAccountableAccountDialog: boolean = false;

    openMailDialog(item, reminder) {
        console.log(item.index);
        this.selectedAccountingTransactionKeys = [item.index];
        this.reminder = reminder;
        this.getDefaultMailer();
    }

    openReminderMailDialog(item, reminder, reminderType) {
        this.selectedAccountingTransactionKeys = [item.index];
        this.reminder = reminder;
        this.reminderType = reminderType;
        this.getDefaultMailer();
    }

    get addCheckBoxColumn() {
        if (this.openPointMode) {
            return !!this.candidateBankTransactionsForMessage.length;
        }
        return true;
    }

    get thirdPartyCompanyId() {
        // if(this.accountableAccountInfo?.thirdPartyCompanyId) {
        //     return this.accountableAccountInfo?.thirdPartyCompanyId
        // }
        // return null
        if (this.accountingTransactions?.length) {
            return this.accountingTransactions[0].thirdPartyCompanyId;
        }
        return null;
    }

    get thirdPartyName() {
        if (this.accountableAccountInfo?.thirdPartyCompanyName) {
            return this.accountableAccountInfo?.thirdPartyCompanyName;
        }
        if (this.accountableAccountInfo.firstname || this.accountableAccountInfo.lastname) {
            return getUserDisplayName(this.accountableAccountInfo);
        }
        return "";
    }

    get thirdPartyUserId() {
        if (this.accountableAccountInfo?.userId) {
            return this.accountableAccountInfo?.userId;
        }
        return null;
    }

    get height() {
        if (this.accountingTransactions.length)
            return "min(" + (56 * (this.accountingTransactions.length + 2) + 40) + "px, 60vh)";
        return "100%";
    }

    /** modified by Eric */
    isCheckable(item) {
        if (this.openPointMode) {
            if (
                item.object.type === "bankTransaction" &&
                (!item.chat ||
                    !item.chat.lastMessage.sender.company ||
                    !item.chat.lastMessage.sender.company.accountingFirm)
            ) {
                return true;
            }
        }
        return true;
    }

    get showPaymentManager() {
        if (this.outStandingMode) {
            if (
                this.accountableAccountInfo.name?.startsWith("401") ||
                this.accountableAccountInfo.name?.startsWith("411") ||
                this.accountableAccountInfo.name?.startsWith("421") ||
                this.accountableAccountInfo.name?.startsWith("425") ||
                this.accountableAccountInfo.name?.startsWith("4671")
            ) {
                return true;
            }
        }

        return false;
    }

    get disabledPaymentManager() {
        if (!this.selectedAccountingTransactions.length) {
            return true;
        }
        for (const accountingTransaction of this.selectedAccountingTransactions) {
            if (accountingTransaction.object?.type !== "document") {
                return true;
            }
        }
    }

    get resetedSelectedAccountingTransactions() {
        const ats = JSON.parse(JSON.stringify(this.selectedAccountingTransactions));
        for (const at of ats) {
            at.stillOwe = at.amountSigned;
            at.personalisedAmountSigned = at.amountSigned;
        }
        return ats;
    }

    get isForClients() {
        if (this.accountableAccountInfo.name?.startsWith("411000")) {
            return true;
        }
        return false;
    }

    get documentType() {
        if (this.accountableAccountInfo.name?.startsWith("401000")) {
            return "PURCHASE_INVOICE";
        }
        if (this.accountableAccountInfo.name?.startsWith("411000")) {
            return "SALES_INVOICE";
        }
        if (this.accountableAccountInfo.name?.startsWith("421000")) {
            return "PAY_SLYP";
        }
        if (
            this.accountableAccountInfo.name?.startsWith("425000") ||
            this.accountableAccountInfo.name?.startsWith("467100")
        ) {
            return "EXPENSE_REPORT";
        }
        return "";
    }

    get disabledPay() {
        if (this.totalBalance > 0) {
            return true;
        }
        return false;
    }

    get hasNotPurchasedOrSaleInvoices() {
        for (const at of this.accountingTransactions) {
            if (at.log === "PURCHASE_INVOICE" || at.log === "SALES_INVOICE") {
                return false;
            }
        }
        return true;
    }

    get allColumnsExceptTwo() {
        return this.headers.length;
        // if(this.addCheckBoxColumn) {
        //     return this.headers.length - 1
        // }
        // return this.headers.length - 2
    }

    async getDefaultMailer() {
        const result = await this.$apollo.query({
            query: GET_DEFAULT_MAILER,
            fetchPolicy: "network-only",
            variables: {
                total: this.totalBalance,
                isForClients: this.isForClients,
                reminder: this.reminder,
                reminderType: this.reminderType,
                listDocuments: this.selectedAccountingTransactions,
                userId: this.$store.state.user.id,
                displayBudgetInsightURL: false,
                companyId: this.companyId,
            },
        });
        console.log(result);
        this.documentDefaultMailerInfos = result.data.getDefaultMailer;
        this.sendMailDialog = true;
    }

    /* modified by Eric */
    get headers() {
        const headers = [];

        // if (this.addCheckBoxColumn) {
        //     headers.push({ text: "", value: "a", sortable: false, align: "" })
        // }
        headers.push({ text: "Statut", value: "status", sortable: false, align: "left" });
        headers.push({ text: "Type", value: "type", sortable: false, align: "left" });
        // { text: "Numéro", value: "number", sortable: false, align: "center" },
        headers.push({ text: "Libellé", value: "wording", sortable: false, align: "left" });
        headers.push({ text: "Date", value: "date", sortable: false, align: "center" });

        headers.push({ text: "Montant", value: "amountSigned", sortable: false, align: "right" });
        headers.push({
            text: "Montant Restant",
            value: "stillOwe",
            sortable: false,
            align: "right",
        });
        // headers.push({ text: "", value: "", sortable: false, align: "center" })
        // headers.push({ text: "", value: "", sortable: false, align: "center" })

        if (this.outStandingMode) {
            headers.push({ text: "Action", value: "action", sortable: false, align: "center" });
        }

        return headers;
    }

    get modifyAATitle() {
        if (!this.isAccountingUser) {
            return "Affecter";
        }
        return "Modifier le compte";
    }

    @Watch("sendMailDialog")
    deleteInfosFromPaymentManagement() {
        if (!this.sendMailDialog) {
            // this.listDocumentsFromPaymentManagement = []
            this.totalFromPaymentManagement = 0;
            // this.oneDocument = null
        }
    }

    compute(accountingTransactions) {
        let absoluteMax = 0;
        for (const at of accountingTransactions) {
            at.amountSigned = at.debit - at.credit;
            at.personalisedAmountSigned = at.stillOwe;
            if (absoluteMax < Math.abs(at.balance)) {
                absoluteMax = Math.abs(at.balance);
            }
        }
        for (const at of accountingTransactions) {
            at.percentage = (100 * at.balance) / absoluteMax;
        }
        accountingTransactions.sort((a, b) => {
            if (a.date < b.date) return -1;
            if (a.date > b.date) return 1;
            return 0;
        });
        this.afterCompute(accountingTransactions);
    }

    // sendMailFromPM(event) {
    //     this.totalFromPaymentManagement = event.total
    //     this.sendMailDialog = true
    // }

    onActionDone() {
        this.refresh();
    }

    beforeMount() {
        if (this.inAccountingTransactions && this.inAccountingTransactions.length) {
            const _inAccountingTransactions = this.btOnly
                ? this.inAccountingTransactions.filter((e) => e.log !== "MISCELLANEOUS_OPERATION")
                : this.inAccountingTransactions;
            this.compute(_inAccountingTransactions);
            this.workingAccountingTransactions = _inAccountingTransactions;
        }
    }

    //
    // OPEN POINTS
    //

    diffStatus(accountingTransaction) {
        if (accountingTransaction.object.type === "document") {
            if (!accountingTransaction.reconciliationId) {
                const date = accountingTransaction.date || accountingTransaction.dueDate;
                if (date) {
                    return moment(date).diff(moment(), "days");
                }
            }
        } else if (accountingTransaction.object.type === "bankTransaction") {
            if (
                accountingTransaction.status === "INFORMATION_REQUEST" &&
                accountingTransaction.chat &&
                accountingTransaction.chat.lastMessage
            ) {
                return moment(accountingTransaction.chat.lastMessage.createdAt).diff(
                    moment(),
                    "days",
                );
            }
        }
        return undefined;
    }

    statusColor(accountingTransaction) {
        const diff = this.diffStatus(accountingTransaction);
        if (diff !== undefined) {
            if (
                accountingTransaction.object.type === "bankTransaction" &&
                accountingTransaction.chat &&
                accountingTransaction.chat.lastMessage.sender.company &&
                !accountingTransaction.chat.lastMessage.sender.company.accountingFirm
            ) {
                return "green";
            }
            if (diff < 0) {
                if (diff < -30) {
                    return "red";
                }
                return "orange";
            }
            // if (diff >= 0) {
            return "blue";
            // }
        }
        return "green";
    }

    statusIcon(accountingTransaction) {
        const diff = this.diffStatus(accountingTransaction);
        if (diff !== undefined) {
            if (accountingTransaction.object.type === "bankTransaction") {
                return "$fa-comments";
            } else if (accountingTransaction.object.type === "document") {
                // if (accountingTransaction.chat && !accountingTransaction.chat.lastMessage.sender.company.accountingFirm) {
                //     return "done"
                // }
                if (diff < 0) {
                    return "$oss-warning";
                }
                return "$av_timer";
            }
        }
        return "";
    }

    status(accountingTransaction) {
        if (accountingTransaction.object.type === "document") {
            const diff = this.diffStatus(accountingTransaction);
            if (diff !== undefined) {
                if (diff < 0) {
                    return this.$t("document.dueDate.late", { diff: -diff }, -diff);
                }
                // if (diff >= 0) {
                return this.$t("document.dueDate.wait", { diff: diff }, diff);
                // }
            }
            return "Réglé";
        } else if (accountingTransaction.object.type === "bankTransaction") {
            const diff = this.diffStatus(accountingTransaction);
            if (diff !== undefined) {
                if (diff <= 0) {
                    if (
                        accountingTransaction.chat &&
                        accountingTransaction.chat.lastMessage.sender.company &&
                        !accountingTransaction.chat.lastMessage.sender.company.accountingFirm
                    ) {
                        return this.$t("chat.responded", { diff: -diff }, -diff);
                    }
                    return this.$t("chat.reminder", { diff: -diff }, -diff);
                }
            }
            return "";
        }
        return "";
    }

    formatStillOwe(stillOwe, type) {
        if (stillOwe === 0) {
            if (type === "document") {
                return "Réglé";
            } else {
                return "-";
            }
        } else {
            return this.newCommonFormatCurrency(stillOwe, undefined);
        }
    }

    formatMailStatus(lastSentMail) {
        if (lastSentMail && lastSentMail.id) {
            let mailInfo =
                this.formatMailType(lastSentMail.type) +
                " le " +
                this.formatDate(lastSentMail.date);
            if (lastSentMail.lastReadDate) {
                mailInfo += " et lu le " + this.formatDate(lastSentMail.lastReadDate);
            }
            return mailInfo;
        }
        return "";
    }

    formatMailType(mailType) {
        if (mailType === "DUN_REQUEST") {
            return "Relancé";
        }
        if (mailType === "DEFFERED_PAYMENT_REQUEST") {
            return "Demande de délai";
        }
        return "Contacté";
    }

    accessToMails() {
        this.$router.push({
            name: "documents",
            params: {
                resetFilter: "true",
                type: "MAIL",
                thirdPartyCompanyId: this.thirdPartyCompanyId,
                thirdPartyCompanyName: this.accountableAccountInfo?.thirdPartyCompanyName
                    ? this.accountableAccountInfo.thirdPartyCompanyName
                    : "",
            },
        });
    }

    @Apollo({
        query() {
            return MAILS_FILTER_QUERY;
        },
        variables() {
            return {
                companyId: this.selectedCompany.id,
                thirdPartyCompany: this.thirdPartyCompanyId
                    ? { id: this.thirdPartyCompanyId }
                    : undefined,
            };
        },
        skip() {
            return !this.selectedCompany || !this.selectedCompany.id || !this.thirdPartyCompanyId;
        },
        specificResult({ data, loading }: any) {
            if (!loading) {
                if (data && data.mails) {
                    this.mails = data.mails;
                } else {
                    this.mails = [];
                }
            }
        },
    })
    mails = [];
}

export default toNative(AccountableAccountBalanceDetailOpenPoints);
</script>
